(() => {
  if (customElements.get('bundle-collection')) {
    return;
  }

  class BundleCollection extends HTMLElement {
    constructor() {
      super();
      this.errorMessage = this.getAttribute('data-error-message');
      this.collectionId = this.getAttribute('data-collection-id');
      this.quantityMin = 0;
      this.quantityMax = null;
      this.selectors = {
        bundleCard: '[data-bundle-card]',
      }
      this.isValid = false;
    }

    get selectedBundleCards() {
      const bundleCards = this.querySelectorAll(`${this.selectors.bundleCard}.is-selected`);
      return [...bundleCards].map(bundleCard => {
        return bundleCard.getBundleData();
      })
    }

    connectedCallback() {
      this.addEventListener('bundle:quantity:update', this.handleQuantityUpdate.bind(this));
    }

    handleQuantityUpdate() {
      const totalQuantity = this.selectedBundleCards.reduce((acc, bundleCard) => {
        return acc + bundleCard.quantity;
      }, 0);

      // If below min
      if (!!this.quantityMin && (totalQuantity < this.quantityMin)) {
        this.updateValidity(false);
        return;
      }

      // If above max
      if (!!this.quantityMax && (totalQuantity > this.quantityMax)) {
        this.updateValidity(false);
        return;
      }

      // If at max
      if (!!this.quantityMax && (totalQuantity === this.quantityMax)) {
        this.updateValidity(true, true);
        return;
      }

      this.updateValidity(true, false);
    }

    updateValidity(isValid, addClass = false) {
      this.classList.toggle('is-valid', isValid && addClass);
      this.isValid = isValid;
    }

    applyQuantityRules(bundleSettings) {
      const variant = bundleSettings.variants[0];
      const optionSources = variant.option_sources;

      const collectionSettings = optionSources.find((optionSource) => {
        return optionSource.option_source_id === this.collectionId;
      });

      if (!collectionSettings) return;

      // Check if there is exactly 1 option source (Update condition for bundle settings 
      // with 1 bundle content as they will only have 1 option source) and if variant 
      // has ranges defined, if so apply quantity rules from ranges instead of collection settings)
      if (optionSources.length === 1 && variant.ranges && variant.ranges.length > 0) {
        // Replace with values from ranges[0]
        this.quantityMax = variant.ranges[0].quantity_max;
        this.quantityMin = variant.ranges[0].quantity_min;
      } else {
        // Default behavior 
        this.quantityMax = collectionSettings.quantity_max;
        this.quantityMin = collectionSettings.quantity_min;
      }

      this.isValid = this.quantityMin === null;
      this.classList.add('has-upper-limit', this.quantityMax !== null);
      this.classList.remove('is-loading');
    }
  }

  customElements.define('bundle-collection', BundleCollection);
})();